import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';


// @ts-ignore
@Component({
    selector: 'snelstart-venture-fiscaal-feature-voorbeeldTeksten',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './voorbeeldTeksten.component.html',
    styleUrl: './voorbeeldTeksten.component.scss',
})

export interface VoorbeeldTekst {
    label: string;
    value: string;
    belastingMiddelen?: ('IH' | 'VPB' | 'OB')[];
    belastingSoort?: ('NHA' | 'ASLG' | 'AMBA' | 'BBB' | 'NVAS' | 'BLSR' | 'OVER' | 'VLBS' )[];
    bezwaarBox3?: boolean
}

export const VOORBEELDTEKSTEN: VoorbeeldTekst[] = [
        {
            label: 'Algemeen model bezwaar',
            belastingMiddelen: ['IH'],
            belastingSoort: ['ASLG'],
            bezwaarBox3: false,
            value: 'Geachte inspecteur,\n\n' +
                'Hierbij maak ik namens belastingplichtige {{naamBelanghebbende}} bezwaar tegen een door u opgelegde belastingaanslag.\n' +
                'Dit bezwaar richt zich tegen de aanslag inkomstenbelasting/premie volksverzekeringen {{jaar}} met aanslagnummer {{aanslagnummer}}.\n\n' +
                'Ik verzoek u de aanslag te herzien en opnieuw vast te stellen op basis van de onderstaande gegevens.\n' +
                'Ik licht mijn bezwaar als volgt toe:\n\n' +
                '[Motivatie]\n\n' +
                'Ik verzoek u mijn bezwaar gegrond te verklaren en de aanslag overeenkomstig aan te passen. Indien gewenst ben ik bereid mijn bezwaar mondeling toe te lichten. \n' +
                'Ik behoud mij het recht voor dit bezwaarschrift nader aan te vullen.\n\n' +
                'Met vriendelijke groet,\n\n' +
                '{{naamKantoor}}\n' +
                '{{naamContactpersoon}}'
        },
        {
            label: 'Model bezwaar',
            belastingMiddelen: ['VPB'],
            belastingSoort: ['ASLG'],
            bezwaarBox3: false,
            value: 'Geachte inspecteur,\n\n' +
                'Hierbij maak ik namens belastingplichtige {{naamBelanghebbende}} bezwaar tegen een door u opgelegde belastingaanslag.\n' +
                'Dit bezwaar richt zich tegen de aanslag vennootschapsbelasting {{jaar}} met aanslagnummer {{aanslagnummer}}.\n\n\' + ' +
                'Ik verzoek u de aanslag te herzien en opnieuw vast te stellen op basis van de onderstaande gegevens.\n\n' +
                'Ik licht mijn bezwaar als volgt toe:\n\n' +
                '\n' +
                '[Motivatie]\n\n' +
                'Ik verzoek u mijn bezwaar gegrond te verklaren en de aanslag overeenkomstig aan te passen. Indien gewenst ben ik bereid mijn bezwaar mondeling toe te lichten. \n' +
                'Ik behoud mij het recht voor dit bezwaarschrift nader aan te vullen.\n\n' +
                'Met vriendelijke groet,\n\n' +
                '{{naamKantoor}}\n' +
                '{{naamContactpersoon}}'
        },
        // {
        //     label: 'Bezwaar Box 3',
        //     belastingMiddelen: ['IH'],
        //     belastingSoort: ['ASLG'],
        //     bezwaarBox3: true,
        //     value: 'Geachte inspecteur,\n\n' +
        //         'Hierbij maak ik namens belastingplichtige ({{naamBelanghebbende}}) bezwaar tegen de aanslag inkomstenbelasting {{jaar}}. ' +
        //         'Het bezwaarschrift (massaal-bezwaarschrift ex artikel 25c AWR) richt zich tegen de box 3 heffing welke ' +
        //         'is opgenomen in de aangifte Inkomstenbelasting {{jaar}.\n\n' +
        //         'FEITEN\n' +
        //         'De aanslag is opgelegd naar aanleiding van een vermogen van € [INVULLEN]. ' +
        //         'De verschuldigde inkomstenbelasting (op aanslag) over dit box 3 vermogen bedraagt € [INVULLEN].\n\n' +
        //         'BEZWAREN EN MOTIVERING\n' +
        //         'De box 3 heffing is naar mijn mening en die van de rechter in strijd met artikel 1 van het Europese ' +
        //         'Verdrag tot bescherming van de rechten van de mens (EVRM), zonder dat de schending van de ' +
        //         '"fair balance" op het niveau van de individuele belastingplichtige wordt beoordeeld. Ook kan ' +
        //         'het zijn dat de heffing in strijd is met artikel 14 EVRM. Vorenstaande is door de Hoge ' +
        //         'Raad vastgesteld op 24 december 2021 (ECLI:NL:HR:2021:1963). In dit arrest wordt de wettelijke ' +
        //         'regeling in 2017 aan de orde gesteld, de essentie van de grondslagen en het forfait zijn thans niet ' +
        //         'echt aangepast. De Hoge Raad is van mening dat er enkel mag worden geheven over het werkelijke rendement ' +
        //         'dat door belastingplichtige is genoten, dit rendement bedraagt € [INVULLEN] minus kosten € [INVULLEN] = € [INVULLEN]. ' +
        //         'De heffing in box 3 bedroeg € [INVULLEN]. Ik verzoek u dan ook de aanslag te verminderen met € [INVULLEN].\n\n' +
        //         'Ter motivering merk ik op dat de vermogensrendementsheffing zoals is vastgelegd in artikel 5.2 ' +
        //         'eerste lid van de Wet op de Inkomstenbelasting 2001 (in mijn situatie) in strijd is met ' +
        //         'bovengenoemd artikel 1 EP van het EVRM. In onderhavig geval is sprake van een inbreuk op het ' +
        //         'eigendomsrecht en eventueel van een individuele en excessieve belastingheffing op het beleggingsvermogen in box 3.\n\n' +
        //         'CONCLUSIE\n' +
        //         'Ik verzoek u de aanslag te verminderen met het bedrag dat samenhangt met de in aangifte inkomstenbelasting {{jaar}} ' +
        //         'opgenomen box 3 heffing,de hierover verschuldigde belasting bedraagt € [INVULLEN].\n\n' +
        //         'Ik verzoek u dit bezwaarschrift aan te houden tot dat er duidelijkheid is. ' +
        //         'Indien gewenst ben ik bereid mijn bezwaar mondeling toe te lichten. \n' +
        //         'Ik behoud mij het recht voor dit bezwaarschrift nader aan te vullen.\n\n' +
        //         'Met vriendelijke groet,\n\n' +
        //         '{{naamKantoor}}\n' +
        //         '{{naamContactpersoon}}'
        // },
        {
            label: 'Mediation',
            belastingMiddelen: ['IH', 'VPB', 'OB'],
            value: 'Mediation\n' +
                'Indien u van oordeel bent dat het bezwaarschrift niet volledig gegrond kan worden verklaard, dan ben ik bereid om ' +
                'met u in overleg te treden om tot een oplossing te komen. Ik sta open voor de mogelijkheid om dit geschil op te lossen via mediation, ' +
                'zoals bedoeld in de Leidraad Mediation van de Belastingdienst. ' +
                'Ik verzoek u mij in dat geval uit te nodigen voor een mediationtraject of om te onderzoeken of informele afhandeling mogelijk is.'
        },
        {
            label: 'Uitstel van betaling',
            belastingMiddelen: ['IH', 'VPB', 'OB'],
            value: 'Uitstel van betaling\n' +
                'In verband met het ingediende bezwaarschrift verzoek ik u om uitstel van betaling voor het bedrag van € [INVULLEN], ' +
                'zijnde het belastingbedrag dat samenhangt met dit bezwaar.\n' + '' +
                'Ik verzoek u dit verzoek – voor zover nodig – door te geleiden naar de invorderingsafdeling. ' +
                'Het door belastingplichtige verschuldigde bedrag wordt uiterlijk op de reguliere betaaldatum voldaan, ' +
                'tenzij anders overeengekomen.\n' +
                'Mocht aanvullende informatie benodigd zijn voor de beoordeling van dit uitstelverzoek, dan hoor ik dat graag.'
        },
        {
            label: 'Horen',
            belastingMiddelen: ['IH', 'VPB', 'OB'],
            value: 'Horen\n' +
                'Tenslotte verzoek ik u mij te horen als u voornemende bent van dit bezwaarschrift af te wijken. ' +
                'Ik verneem dan graag vóór het horen schriftelijk uw argumenten en motivatie waarom u niet voornemende bent om ' +
                '(volledig) aan de bezwaren tegemoet te komen.'
        },
        {
            label: 'Dossierinzage',
            belastingMiddelen: ['IH', 'VPB', 'OB'],
            value: 'Dossierinzage\n' +
                'Ik verzoek u om inzage in het dossier van belastingplichtige, wanneer kan dit plaatsvinden? Als uit deze dossierinzage informatie ' +
                'volgt die de bezwaren kunnen complementeren, dan verzoek ik u mij toe te staan deze alsnog aan te vullen. ' +
                'Voor de formele gang kunt u dit bezwaarschrift dan aanmerken als pro forma bezwaarschrift.'
        },
        {
            label: 'Slotzin & ondertekening',
            belastingMiddelen: ['IH', 'VPB', 'OB'],
            value: 'Ik verzoek u mijn bezwaar gegrond te verklaren en de aanslag overeenkomstig aan te passen. Indien gewenst ben ik bereid mijn bezwaar mondeling toe te lichten. \n' +
                'Ik behoud mij het recht voor dit bezwaarschrift nader aan te vullen.\n\n' +
                'Met vriendelijke groet,\n\n' +
                '{{naamKantoor}}\n' +
                '{{naamContactpersoon}}'
        }

    ]
;
